import React from 'react';

import CustomExports from '../components/exports/CustomExports';
import ApptopiaExports from '../components/exports/ApptopiaExports';
import Container from '../../../components/Container';
import ExportsTable from '../components/exports/ExportsTable';
import ReportsTable from '../components/exports/ReportsTable';
import { initParams } from '../configs';

// Dev notes: remove ExportsTable/ and ReportsTable/ folders after allowCustomExportSchedulingProgress
// permission is removed and all users are migrated to the new custom exports experience

const allowSchedulingProgress = initParams.permissions.allowCustomExportSchedulingProgress;

const Exports = () =>
  allowSchedulingProgress ? (
    <Container maxWidth={1128} className="py-mdl">
      <div className="stack-vertical gap-24">
        <CustomExports />
        <ApptopiaExports />
      </div>
    </Container>
  ) : (
    <Container className="custom-exports-legacy" gutters={32}>
      <ExportsTable />
      <ReportsTable />
    </Container>
  );

export default Exports;
